import React, { forwardRef, useImperativeHandle, useState } from 'react'

import {
  AutenticacaoContainer,
  Botao,
  FormUnform,
  InputUnform,
  ModalBase,
  Visao
} from 'src/componentes'
import { SelectDefaultValue } from 'src/componentes/unform/select/selectDefaultValue'

import { createSchema } from './schema'
import { ContainerBotoes, Corpo } from './styles'
import {
  ModalVincularDisciplinaModuloProps,
  ModalVincularDisciplinaModuloRef
} from './tipos'

const ModalVincularDisciplina: React.ForwardRefRenderFunction<
  ModalVincularDisciplinaModuloRef,
  ModalVincularDisciplinaModuloProps
> = (
  { backdrop, acaoPrimaria, acaoSecundaria, titulo, opcoesProfessor },
  ref
) => {
  const { visao } = AutenticacaoContainer.useContainer()
  // const professorNome = professor?.nomeProfessor ?? ''
  // const professorId = professor?.idProfessor ?? ''
  const [aberta, definirAberta] = useState(false)
  const [pronto, definirPronto] = useState(false)
  const [dadosIniciais, definirDadosIniciais] = useState<any>(null)
  const [indexModulo, definirIndexModulo] = useState<number | null>(null)
  const [indexDisciplina, definirIndexDisciplina] = useState<number | null>(
    null
  )
  const [modo, definirModo] = useState<'incluir' | 'editar'>('incluir')

  const fechar = () => {
    definirPronto(false)
    definirAberta(false)
  }

  const abrir = (
    disciplina?: any,
    idxModulo?: number,
    idxDisciplina?: number
  ) => {
    if (disciplina) {
      definirModo('editar')

      definirIndexModulo(idxModulo ?? null)
      definirIndexDisciplina(idxDisciplina ?? null)

      definirDadosIniciais({
        id: disciplina.id,
        nome: disciplina.nome,
        cargaHoraria: disciplina.cargaHoraria,
        professor:
          disciplina?.professorDisciplinasModuloCertificacao?.[0]
            ?.idProfessor ?? ''
      })
    } else {
      definirModo('incluir')
      definirDadosIniciais(null)
    }

    definirPronto(true)
    definirAberta(true)
  }

  useImperativeHandle<
    ModalVincularDisciplinaModuloRef,
    ModalVincularDisciplinaModuloRef
  >(ref, () => ({
    fechar,
    abrir
  }))

  const acaoSucesso = async (dados: any) => {
    acaoPrimaria({
      ...dados,
      id: dadosIniciais?.id,
      modo,
      indexModulo,
      indexDisciplina
    })
    fechar()
  }

  return (
    <ModalBase aberta={aberta} backdrop={backdrop}>
      <Corpo style={{ width: '500px' }}>
        <h5> {titulo} </h5>
        {pronto && (
          <FormUnform
            key={dadosIniciais?.professor || 'novo'}
            acaoSucesso={acaoSucesso}
            schema={createSchema}
            dadosIniciais={dadosIniciais}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '15px'
              }}
            >
              <div style={{ width: '100%' }}>
                <InputUnform
                  name="nome"
                  label="Nome da Disciplina"
                  obrigatorio
                  maxLength={200}
                />
                <SelectDefaultValue
                  id="select1"
                  name="professor"
                  label="Professor"
                  opcoes={opcoesProfessor}
                  obrigatorio
                  defaultValue={dadosIniciais?.professor}
                  disabled={visao !== Visao.ParceiroCertificacao}
                />
                <InputUnform
                  name="cargaHoraria"
                  label="Carga Horária"
                  obrigatorio
                  maxLength={200}
                />
              </div>
            </div>
            <ContainerBotoes>
              <Botao
                type="button"
                id="btn-cancelar"
                texto="Cancelar"
                tema="Secundario"
                onClick={() => {
                  acaoSecundaria && acaoSecundaria()
                  fechar()
                }}
              />
              <Botao type="submit" id="btn-salvar" texto="Vincular" />
            </ContainerBotoes>
          </FormUnform>
        )}
      </Corpo>
    </ModalBase>
  )
}

export const ModalVincularDisciplinaModulo = forwardRef(ModalVincularDisciplina)
